import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaMapMarkedAlt,
  FaTruck,
  FaWarehouse,
  FaStore,
  FaHandshake,
  FaClock
} from "react-icons/fa";

const networkData = [
  {
    icon: <FaMapMarkedAlt />,
    title: "Pan-India Presence",
    text: "Our distribution network spans major agricultural regions across India.",
    image: "/images/img/dist-india.jpg",
  },
  {
    icon: <FaWarehouse />,
    title: "Strategic Warehousing",
    text: "Well-located storage facilities ensure product safety and quick dispatch.",
    image: "/images/img/dist-warehouse.jpg",
  },
  {
    icon: <FaTruck />,
    title: "Efficient Logistics",
    text: "Planned logistics systems ensure timely delivery during critical crop stages.",
    image: "/images/img/dist-logistics.jpg",
  },
  {
    icon: <FaStore />,
    title: "Dealer Network",
    text: "Strong partnerships with dealers guarantee product availability and service.",
    image: "/images/img/dist-dealer.png",
  },
  {
    icon: <FaHandshake />,
    title: "Distributor Partnerships",
    text: "Trusted distributors help maintain consistent reach and market support.",
    image: "/images/img/dist-partner.png",
  },
  {
    icon: <FaClock />,
    title: "On-Time Availability",
    text: "Right products reach farmers at the right time, season after season.",
    image: "/images/img/dist-time.png",
  },
];

const DistributionNetwork = () => {
  return (
    <section className="section distribution-section">
      <Container>

        {/* Common Section Heading */}
        <div className="section-title fade-up">
          <h2>Distribution Network</h2>
          <p>
            A strong supply chain connecting Hindustan Agro Life solutions
            directly to farmers across India.
          </p>
        </div>

        <Row>
          {networkData.map((item, index) => (
            <Col lg={4} md={6} className="mb-4 fade-up" key={index}>
              <div className="distribution-card">

                <div className="distribution-image">
                  <img src={item.image} alt={item.title} />
                </div>

                <div className="distribution-content">
                  <div className="distribution-icon">
                    {item.icon}
                  </div>
                  <h4>{item.title}</h4>
                  <p>{item.text}</p>
                </div>

              </div>
            </Col>
          ))}
        </Row>

      </Container>
    </section>
  );
};

export default DistributionNetwork;
